<template>
  <div class="pulse-dialog__header">
    <div class="pulse-dialog__heading">
      <div v-if="icon" class="pulse-dialog__icon">
        <i :class="icon" />
      </div>
      <div class="min-width-0">
        <h3 class="pulse-dialog__title">{{ title }}</h3>
        <div v-if="subtitle" class="pulse-dialog__subtitle">{{ subtitle }}</div>
      </div>
    </div>
    <div class="pulse-dialog__header-actions">
      <slot />
      <pulse-button
        v-if="closable"
        icon="pi pi-times"
        severity="secondary"
        text
        rounded
        title="Fechar"
        :disabled="closeDisabled"
        @click="$emit('close')"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "PulseDialogHeader",
  props: {
    title: { type: String, required: true },
    subtitle: { type: String, default: "" },
    icon: { type: String, default: "" },
    closable: { type: Boolean, default: true },
    closeDisabled: Boolean,
  },
};
</script>
